import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EntregaProjeto } from '../../models/entregas-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { EntregasProjetoService } from '../../services/entregas-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-entrega-projeto-relatorio',
  templateUrl: './detalhe-entrega-projeto-relatorio.component.html',
  styleUrls: ['./detalhe-entrega-projeto-relatorio.component.scss']
})
export class DetalheEntregaProjetoRelatorioComponent extends BaseListComponent<EntregaProjeto> implements OnInit, OnDestroy {
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  idEntrega: number;
  itensRelatorio: any;
  entrega: any;

  constructor(
    private myService: EntregasProjetoService,
    private activatedRoute: ActivatedRoute,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super()
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.loading();
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.idEntrega = this.activatedRoute.snapshot.params?.id;
      this.itensRelatorio = this.myService.getItensRelatorio();
    });

    this.addSub(
      this.myService.getRelatorio(this.idEntrega, this.itensRelatorio).subscribe({
        next: (res) => {
          this.entrega = res;
          this.loaded();
        },
        error: (err) => {
          this.loaded();
          this.msgError(err.error?.message);
        },
      }),
    );
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }
}
